'use strict';

import Component from 'generic.basecomponent';
import {ATTRIBUTE_VALIDATE_NEVER} from '../../form/js/generic.form';

export default class ShowRule extends Component {

    /**
     * example config
     * {
     *  elements: "id1,id2:false,id3:concreteValue"
     *  condition: 'and'
        action: 'show' //hide, class
        class: 'example-class' // if action is class
     * }
     *
     * @param el
     */
    constructor(el) {
        super(el);
        this.idAttributeName = 'data-rule-id';
        this.config = {
            action: 'show',
            condition: 'and'
        };
        this.elementsValues = {};
        this.lastResult = undefined;
        this.init();
    }

    init() {
        let configString = this.container.getAttribute('data-rule');
        let config = {};
        try {
            config = JSON.parse(configString);
        } catch (e) {
            //maybe we pass single string to set elements only
            config = {elements: configString};
        }

        let elementsString = config.elements;
        if (elementsString) {
            let elements = [];
            let elementsConditions = {};
            config.elements.split(',').forEach((elementCondition) => {
                let [elementId, elementValue] = elementCondition.trim().split(':');


                let elementNodes = document.querySelectorAll(`[${this.idAttributeName}="${elementId}"]`);
                for (let i = 0; i < elementNodes.length; i++) {
                    if (elementNodes[i].tagName === 'INPUT') {
                        elements.push(elementNodes[i]);
                        if (!elementsConditions[elementId]) {
                            elementsConditions[elementId] = (elementValue === undefined || elementValue === 'true') ? true : (elementValue === 'false' ? false : elementValue);
                        }
                    }
                }
            });
            config.elementsConditions = elementsConditions;
            if (elements.length) {
                this.bootstrap(config, elements);
            }
        }
    }

    getElementId(element) {
        return element.getAttribute(this.idAttributeName);
    }

    bootstrap(configPart, elements) {
        Object.assign(this.config, configPart);
        this.elementsValues = elements.reduce((result, element) => {
            result[this.getElementId(element)] = this.getElementValue(element);
            return result;
        }, {});

        elements.forEach((element) => {
            if (element.type === 'text') {
                element.addEventListener('input', this.onElementChange.bind(this));
            } else {
                element.addEventListener('change', this.onElementChange.bind(this));
            }
        });
        this.manage();
    }

    getElementValue(element) {
        switch (element.type) {
            case 'checkbox':
                return element.checked;
            case 'radio':
                return element.checked ? element.value : false;
            default:
                return element.value;
        }
    }

    onElementChange(e) {
        let element = e.target;
        this.elementsValues[this.getElementId(element)] = this.getElementValue(element);
        this.manage();
    }

    manage() {
        let result = false;

        let checkFunction = (id) => {
            return this.elementsValues[id] === this.config.elementsConditions[id];
        };

        if (this.config.condition === 'and') {
            result = Object.keys(this.elementsValues).every(checkFunction);
        } else {
            result = Object.keys(this.elementsValues).some(checkFunction);
        }
        if (result !== this.lastResult) {
            this.update(result)
        }
    }

    update(result) {
        this.lastResult = result;
        switch (this.config.action) {
            case 'show':
                this.updateShow(result);
                break;
            case 'hide':
                this.updateShow(!result);
                break;
            case 'class':
                this.updateClass(result);
                break;
        }
    }

    updateShow(result) {
        if (result) {
            this.container.style.display = 'block';
            this.container.removeAttribute(ATTRIBUTE_VALIDATE_NEVER);
        } else {
            this.container.style.display = 'none';
            this.container.setAttribute(ATTRIBUTE_VALIDATE_NEVER, '');
        }
    }

    updateClass(result) {
        if (result) {
            this.container.classList.add(this.config.class);
        } else {
            this.container.classList.remove(this.config.class);
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/show-rule/js/generic.show-rule.js